import Title from "./Title";
import s1 from '../img/services/s1.png';
import s2 from '../img/services/s2.png';
import s3 from '../img/services/s3.png';
import s4 from '../img/services/s4.png';
import localmoveIcon from '../img/icon/localmoving.png';
import longdistance from '../img/icon/longdistance.png';
import officemoving from '../img/icon/officemoving.png';
import Btn from "./Btn";
import Checklist from "./Checklist";

export default function ExploreAll() { 
    return <>
        <div className="explorealls   pb-5 pt-0 pt-sm-3 pt-lg-5" >
            <div className="container" >
                <Title mainClass="text-center m-auto d-table"
                    titleclass="lg text-dark mb-2"
                    desclass="text-center mt-3 mb-2"
                    title={<>Explore All Our Services <br></br> we provide!</>}
                    des="Our goal is to tailor each experience to specifically fit all moving needs."
                />

                <div className="serviceSec pt-5 pb-5" >
                    <div className="row " >
                        <div className="col-lg-6" >
                            <Title mainClass="mb-3"
                                subheading="SERVICE:MOVING"
                                subclass="mb-2 border-none text-start text-uppercase"
                                titleclass="lg heading text-dark text-start mb-3 mt-0 mt-lg-3"
                                desclass="mb-0"
                                serial="1"
                                title={<>Highest Quality Moving Service</>}
                                des="Our professional moving team is dedicated to providing the highest quality service for every move, no matter how big or small."
                            />
                            <div className="list2 sm" >
                                <ul>
                                    <li>
                                        <div className="servIcon" >
                                            <img src={localmoveIcon} className="img-fluid" alt="service" />
                                        </div>
                                        <div className="servCon" >
                                            <h2>Local Moving</h2>
                                            <p>When it comes to residential local moving, there’s no such thing as a “one size fits all” solution.</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="servIcon" >
                                            <img src={longdistance} className="img-fluid" alt="service" />
                                        </div>
                                        <div className="servCon" >
                                            <h2>Long  Distance Moving</h2>
                                            <p>As a full-service long distance moving company, we know what it takes to make a successful long-distance transition.</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="servIcon" >
                                            <img src={officemoving} className="img-fluid" alt="service" />
                                        </div>
                                        <div className="servCon" >
                                            <h2>Office & Business Moving</h2>
                                            <p>Professional Corporate Relocation Solutions. Our Team of Business moving will go beyond to make sure we exceed your Business expectations.</p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <Btn class="mt-4"
                                arrow={true}
                                wave={true}
                                wavedark={true}
                                href="#"
                            >Book now Moving Service</Btn>
                        </div>
                        <div className="col-lg-6 pt-3 pt-lg-0 ps-lg-5" >
                            <img src={s1} className="img-fluid" alt="services" />
                        </div>

                    </div>
                </div>

                <div className="serviceSec pt-5 pb-5" >
                    <div className="row align-items-center flex-lg-row-reverse" >
                        <div className="col-lg-6" >
                            <Title mainClass="mb-3"
                                subheading="Service: junk removal"
                                subclass="mb-2 border-none text-start text-uppercase"
                                titleclass="lg heading text-dark text-start mb-3 mt-0 mt-lg-3"
                                desclass="mb-0"
                                serial="2"
                                title={<>Our Eco-Friendly Junk
                                    Removal Services</>}
                                des="Preparing your home for an upcoming move? Decluttering your home of unwanted junk? Cleaning out your office or estate?"
                            />
                            <div className="list2" >
                                <ul>
                                    <li>
                                        <div className="servIcon count" >
                                            <span>1</span>
                                        </div>
                                        <div className="servCon" >
                                            <h2>Appliance Removal & Recycling</h2>
                                            <p>Appliances are difficult and dangerous to move. Let us help with your appliance removal needs!</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="servIcon count" >
                                            <span>2</span>
                                        </div>
                                        <div className="servCon" >
                                            <h2>Mattress Disposal Services</h2>
                                            <p>Hauling away a mattress and box spring is never a fun or easy task. That's where we come in!</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="servIcon count" >
                                            <span>3</span>
                                        </div>
                                        <div className="servCon" >
                                            <h2>Get Help Cleaning Out Your Garage!</h2>
                                            <p>We understand you have a lot of options when it comes to hiring someone to help you clean out your garage. </p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <Btn class="mt-4"
                                arrow={true}
                                wave={true}
                                wavedark={true}
                                href="#"
                            >Book now Junk Removal Service</Btn>
                        </div>
                        <div className="col-lg-6 pt-3 pt-lg-0 pe-lg-5" >
                            <img src={s2} className="img-fluid" alt="services" />
                        </div>
                    </div>
                </div>

                <div className="serviceSec pt-5 pb-5" >
                    <div className="row " >
                        <div className="col-lg-6" >
                            <Title mainClass="mb-3"
                                subheading="Service: DONATION PICKUPS"
                                subclass="mb-2 border-none text-start"
                                titleclass="lg heading text-dark text-start mb-3 mt-0 mt-lg-3"
                                desclass="mb-0"
                                serial="3"
                                title={<>Donation Pickup & Delivery
                                    Services</>}
                                des="We help pick up your unwanted items and give them a new life through our donation pickup and delivery services."
                            />
                            <div className="space my-4 orange" ></div>
                            <h3><strong>Some of our most requested Donation</strong> Pickup Services include:</h3>

                            <Checklist 
                                list={["Home & Garage Items", "Basement Cleanouts", "Storage Unit Cleanouts"]}
                                class="mt-3 mt-lg-4 mb-0 mb-lg-4 text-dark" 
                                col="col-12" 
                                liststyle="rounded"  /> 

                            <Btn class="mt-0"
                                arrow={true}
                                wave={true}
                                wavedark={true}
                                href="#"
                            >Book now Moving Service</Btn>

                        </div>
                        <div className="col-lg-6 pt-3 pt-lg-0 ps-lg-5" >
                            <img src={s3} className="img-fluid" alt="services" />
                        </div>
                    </div>
                </div> 

                <div className="serviceSec pt-5" >
                    <div className="row align-items-center flex-lg-row-reverse" >
                        <div className="col-lg-6" >
                            <Title mainClass="mb-3"
                                subheading="Service: labor"
                                subclass="mb-2 border-none text-start text-uppercase"
                                titleclass="lg heading text-dark text-start mb-3 mt-0 mt-lg-3"
                                desclass="mb-0"
                                serial="4" 
                                title={<>Hourly Labor & Moving
                                    Services</>}
                                des="Sit Back and Let The Exquisite Moves do the Work. Friendly & Affordable Home & Business Service Solutions"
                            /> 

                            <Checklist
                                list={["Hourly Labor Services", "Truck Loading & Unloading Services", "Professional Packing Services"]}
                                class="mt-0 mt-lg-4 mb-0 mb-lg-4  text-dark"
                                col="col-12"
                                liststyle="rounded" />


                            <Btn class="mt-2"
                                arrow={true}
                                wave={true}
                                wavedark={true}
                                href="#"
                            >Book now Labor & Moving Service</Btn>
                        </div>
                        <div className="col-lg-6 pt-3 pt-lg-0 pe-lg-5" >
                            <img src={s4} className="img-fluid" alt="services" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
} 